/**
 * CollapsibleSection — premium animated wrapper for dashboard sections.
 * Persists collapsed state per user via /api/user-preferences/dashboard-layout.
 */
import React from 'react';
import { ChevronDown } from 'lucide-react';

export const CollapsibleSection = ({
  id,
  title,
  hint,
  icon: Icon,
  collapsed,
  onToggle,
  children,
  testId,
  defaultColor = '#FF6B35',
}) => {
  return (
    <section
      data-testid={testId || `collapsible-${id}`}
      className="mb-4 bg-white border border-slate-100 rounded-xl shadow-sm overflow-hidden">
      <button
        type="button"
        onClick={() => onToggle(id)}
        data-testid={`collapsible-toggle-${id}`}
        className="w-full flex items-center justify-between gap-3 px-4 py-3
          hover:bg-slate-50 transition-colors group">
        <div className="flex items-center gap-2.5">
          {Icon && <Icon className="w-4 h-4" style={{ color: defaultColor }} />}
          <h3 className="text-sm font-bold uppercase tracking-wide text-[#2B2D42] text-left">
            {title}
          </h3>
          {hint && (
            <span className="text-[10px] text-[#6C757D] hidden md:inline ml-2">
              {hint}
            </span>
          )}
        </div>
        <ChevronDown
          className={`w-4 h-4 text-slate-400 transition-transform duration-300
            ${collapsed ? '-rotate-90' : 'rotate-0'}`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-in-out
          ${collapsed ? 'grid-rows-[0fr] opacity-0' : 'grid-rows-[1fr] opacity-100'}`}>
        <div className="overflow-hidden">
          <div className="px-4 pb-4 pt-1">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollapsibleSection;
